var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mastercard-4d8844094130711885b5e41b28c9848f.svg",
    clipPath: "url(#clip0_999_889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.635 0.610107H2.66C1.22544 0.610107 0.0625 1.77305 0.0625 3.20761V18.7926C0.0625 20.2272 1.22544 21.3901 2.66 21.3901H28.635C30.0696 21.3901 31.2325 20.2272 31.2325 18.7926V3.20761C31.2325 1.77305 30.0696 0.610107 28.635 0.610107Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.7516 17.4938C15.338 17.4938 18.2453 14.5865 18.2453 11.0001C18.2453 7.4137 15.338 4.50635 11.7516 4.50635C8.16516 4.50635 5.25781 7.4137 5.25781 11.0001C5.25781 14.5865 8.16516 17.4938 11.7516 17.4938Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.5445 17.4938C23.1309 17.4938 26.0383 14.5865 26.0383 11.0001C26.0383 7.4137 23.1309 4.50635 19.5445 4.50635C15.9581 4.50635 13.0508 7.4137 13.0508 11.0001C13.0508 14.5865 15.9581 17.4938 19.5445 17.4938Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6483 5.80469C17.2255 6.98942 18.2458 8.87564 18.2458 11.0002C18.2458 13.1247 17.2255 15.0109 15.6483 16.1956C14.071 15.0109 13.0508 13.1247 13.0508 11.0002C13.0508 8.87564 14.071 6.98942 15.6483 5.80469Z",
    fill: "#FF5F00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_999_889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.17,
    height: 20.78,
    fill: "white",
    transform: "translate(0.0625 0.610107)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.09e9f002c0a37b984f5b438edabb956d.svg";
export { ForwardRef as ReactComponent };